import script from "./ActionMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionMenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./ActionMenuItem.vue?vue&type=style&index=0&id=2ca88f68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca88f68"]])

export default __exports__